
import { SecondaryButton } from 'components/ui';

/**
 * @function TASPositivePayViewChecksNoResultsContent
 * @return {React.Component}
 * @exported true
 * @description The "TAS Positive Pay View Checks" no content view.
 */
export default function TASPositivePayViewChecksNoResultsContent(props) {
    const onAddChecks = props.onAddChecks ?? (() => {});

    return (
        <div className="flex-container flex-vertical no-results-content">
            <div className="search-result-message row">Search Result (0)</div>
            <div className="no-checks-message row">There are no new checks. Please add checks.</div>
            <div className="flex-container flex-horizontal add-checks-button-container row">
                <div className="flex-width"></div>
                <div className="set-width secondary-button-container">
                    <SecondaryButton text="Add Checks" onClick={ onAddChecks } />
                </div>
                <div className="flex-width"></div>
            </div>
        </div>
    );
}